//
//  hooks/platform/useClientPlatform.ts
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-08-19.
//

"use client";

import { useEffect, useState } from "react";

import type { TownLITClientPlatform } from "../../config/townlitDistribution";

function detectClientPlatform(): TownLITClientPlatform {
  if (typeof window === "undefined") {
    return "unknown";
  }

  const navigatorRef = window.navigator;
  const userAgent = navigatorRef.userAgent;
  const platform = navigatorRef.platform ?? "";
  const maxTouchPoints = navigatorRef.maxTouchPoints ?? 0;

  // Covers iPhone, iPad, iPod and modern iPadOS desktop UA.
  const isIOS =
    /iPhone|iPad|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1);

  if (isIOS) {
    return "ios";
  }

  if (/Android/i.test(userAgent)) {
    return "android";
  }

  const isDesktop =
    /Macintosh|Windows NT|CrOS|X11|Linux/i.test(userAgent);

  if (isDesktop) {
    return "desktop";
  }

  return "other";
}

export function useClientPlatform(): TownLITClientPlatform {
  const [platform, setPlatform] =
    useState<TownLITClientPlatform>("unknown");

  useEffect(() => {
    setPlatform(detectClientPlatform());
  }, []);

  return platform;
}